exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ app-t2-card.card-modal-w-55 .t2-card.card-modal,\n:host /deep/ app-t2-card.card-modal-w-55 .t2-card.card-modal .card-content,\n:host /deep/ app-t2-card.card-modal-w-55 .t2-card.card-modal .card-content > .content {\n  overflow: visible !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/components/add-charges-credits/add-charges-credits.component.scss
// module id = 2121
// module chunks = 66